import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import CollectionBaseAdminView from "./CollectionBaseAdminView";
import StagesManager from "../../components/StagesManager";
import Cookies from "universal-cookie";
import { chooseFontColor } from "../../utils/useful";
import QuizPage from "./inquiries/QuizPage";
import PageViewer from "../PageViewer";
import CollectionBaseUserView from "./CollectionBaseUserView";

class InquiriesApplet extends Component {

    state = {
        colors: {
            primaryColor: '#6E9318',
            secondaryColor: '#96C723',
            textColor: '#fff'
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'InquiriesApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
        // // let frames = []
        // // // let framesSections = InquiriesFrames.sections
        // // let framesSections = [
        // //     { key: 'collections', name: '{{lang}}Collections', addNew: 'addCollection', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // //     { key: 'pages', name: '{{lang}}Pages', addNew: 'addPage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // // ]
        // // if (Array.isArray(this.props.frames)) {
        // //     this.props.frames?.forEach(mframe => {
        // //         mframe.key = mframe._id
        // //         mframe.section = 'collections'
        // //         mframe.pageType = 'collection'
        // //         mframe.fetchUrl = 'getRecords'
        // //         mframe.addUrl = 'postRecord'
        // //         mframe.editUrl = 'updateRecord'
        // //         mframe.removeUrl = 'removeRecord'
        // //         mframe.postBody = { hub: "{{appletHub}}", frame: '{{frameId}}', applet: '{{appletId}}' }
        // //         mframe.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
        // //         mframe.customAdd = { title: '{{lang}}Edit Quiz', function: 'changeStage', functionInput: 'addRule' }
        // //         mframe.customEdit = { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' }
        // //         mframe.fields.forEach(field => {
        // //             if (!field.key?.includes('values.')) {
        // //                 field.key = "values." + field.key
        // //             }
        // //         });
        // //         frames.push(mframe)
        // //     });
        // // }
        // // frames = [...frames, ...Object.values(InquiriesFrames.pages)]
        // // console.log('this.props.frames', this.props.frames)
        // // console.log('frammeesss', frames)
        // // let frames = Object.values(InquiriesFrames.pages)
        // // let framesSections = Object.values(InquiriesFrames.sections)
        // this.setState({ frames, framesSections })
        let frames = this.props.frames
        let framesSections = [
            { key: 'collections', name: '{{lang}}Collections', addNew: 'addCollection', icon: '/images/applets-icons/accounting/063-cart.svg' },
            { key: 'pages', name: '{{lang}}Pages', addNew: 'addPage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        ]

        if (Array.isArray(frames)) {
            frames.forEach(element => {
                if (element.type == 'collection') {
                    element.key = element._id
                    element.section = 'collections'
                    element.pageType = 'collection'
                    element.fetchUrl = 'getRecords'
                    element.addUrl = 'postRecord'
                    element.editUrl = 'updateRecord'
                    element.removeUrl = 'removeRecord'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.customAdd = { title: '{{lang}}Edit Quiz', function: 'addInquiry', functionInput: 'addRule' }
                    element.customEdit = { title: '{{lang}}Add Rule', function: 'editInquiry', functionInput: 'addRule' }
                    element.fields.forEach(field => {
                        if (!field.key.includes("values.")) {
                            field.key = "values." + field.key
                        }
                    });
                }
                else if (element.type == 'page') {
                    element.key = element._id
                    element.section = 'pages'
                    element.pageType = 'page'
                    element.fetchUrl = 'getRecords'
                    element.addUrl = 'postRecord'
                    element.editUrl = 'postRecord'
                    element.removeUrl = 'removeRecord'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.fields.forEach(field => {
                        if (!field.key.includes("values.")) {
                            field.key = "values." + field.key
                        }
                    });
                }
            });
        }

        // console.log("frames, ", frames)
        // console.log('frammeesss', frames)

        let currentFrameName = frames ? frames[0]?.name : null

        this.setState({ frames, framesSections, currentFrameName })
        // let data = {}
        // data.applet = this.props.applet


        // let frames = Object.values(CommercePages.pages)
        // let framesSections = Object.values(CommercePages.sections)


        // HttpServices.request('getFrames', data, (fetchResult, fetchError) => {

        //     if (fetchError) {
        //         return
        //     }
        //     let frames = fetchResult.info
        //     let framesSections = [
        //         { key: 'collections', name: '{{lang}}Collections', addNew: true, icon: '/images/applets-icons/accounting/063-cart.svg' },
        //         { key: 'pages', name: '{{lang}}Pages', addNew: true, icon: '/images/applets-icons/accounting/063-cart.svg' },
        //     ]

        //     if (Array.isArray(frames)) {
        //         frames.forEach(element => {
        //             element.key = element._id
        //             element.section = 'collections'
        //             element.pageType = 'collection'
        //             element.fetchUrl = 'getRecords'
        //             element.addUrl = 'postRecord'
        //             element.editUrl = 'postRecord'
        //             element.removeUrl = 'removeRecord'
        //             element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
        //             element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
        //             element.fields.forEach(field => {
        //                 field.key = "values." + field.key
        //             });
        //         });
        //     }


        //     this.setState({ frames, framesSections, currentFrameName: fetchResult.info[0].name })
        // })

    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {

            this.checkDefaultTab()
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }
    setFrame = (frameId) => {
      this.setState({frameId})
    }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.windowData//.split('/')
        // windowPath = windowPath[windowPath.length - 1]

        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        if (!def) {
            def = ''
        }
        if (def === '') {
            pageType = ''
            pageIsValid = true
        }
        if (pageIsValid) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.setState({ path: def, pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else { }
                            })
                        })
                    }, 10);
                })
                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }




    render() {



        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') {

        }

        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`



        return (

            <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>

                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

                    <CollectionBaseAdminView setFrame={this.setFrame} stageName={'admin'} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} permissions={this.props.permissions} appletAccess={this.props.appletAccess} />

                    {/* <PageViewer userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} /> */}

                    <QuizPage stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} frameId={this.state.frameId} />



                </StagesManager>

            </div>
        )
    }



}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InquiriesApplet);
